export type RREventStatusType = "WAREHOUSE" | "НОВО" | "ПОТВЪРДЕНО" | "ОТКАЗАНО" | "ПОДГОТВЕНО" | "ЗАВЪРШЕНО";
export const RREventStatusTypeList = ["НОВО", "ПОТВЪРДЕНО", "ОТКАЗАНО", "ПОДГОТВЕНО", "ЗАВЪРШЕНО"];

export type RREventStatusesType = RREventStatusType[];

export const RREventStatusAll: RREventStatusType[] = ["WAREHOUSE", "НОВО", "ПОТВЪРДЕНО", "ОТКАЗАНО", "ПОДГОТВЕНО", "ЗАВЪРШЕНО"];
export const RREventStatusCurrent: RREventStatusType[] = ["WAREHOUSE", "НОВО", "ПОТВЪРДЕНО", "ПОДГОТВЕНО", "ЗАВЪРШЕНО"];
export const RREventStatusCurrentList: RREventStatusType[] = ["WAREHOUSE", "НОВО", "ПОТВЪРДЕНО", "ПОДГОТВЕНО"];
export const RREventStatusCompleted: RREventStatusType[] = ["ЗАВЪРШЕНО"];
export const RREventStatusRejected: RREventStatusType[] = ["ОТКАЗАНО"];
